import { render, staticRenderFns } from "./controllerList.vue?vue&type=template&id=630112ec"
import script from "./controllerList.vue?vue&type=script&lang=js"
export * from "./controllerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports